// Keep in sync with backend/src/utils/ncfSlug.js.
const MAX_SLUG_LENGTH = 60;

const slugify = (value) => String(value || '')
  .normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const buildNcfSlug = ({ clientName, lastName, jobTitle } = {}) => {
  const slug = [clientName, lastName, jobTitle].map(slugify).filter(Boolean).join('-');
  if (slug.length <= MAX_SLUG_LENGTH) return slug;
  return slug.slice(0, MAX_SLUG_LENGTH).replace(/-[^-]*$/, '') || slug.slice(0, MAX_SLUG_LENGTH);
};

/** The ID is authoritative; the slug is readability only and may be stale or missing. */
export const ncfPath = ({ ncfId, clientName, lastName, jobTitle }) => {
  const slug = buildNcfSlug({ clientName, lastName, jobTitle });
  return `/ncfs/${ncfId}${slug ? `-${slug}` : ''}`;
};

export const ncfPathFromRecord = (record) => ncfPath({
  ncfId: record.ncfId || record.NcfId,
  clientName: record.clientName || record.ClientName,
  lastName: record.candidateLastName || record.CandidateLastName,
  jobTitle: record.jobDivaJobTitle || record.JobDivaJobTitle
});

export const parseNcfId = (routeParam) => String(routeParam || '').match(/^\d+/)?.[0] || null;
